import styled from "styled-components";

export const TabHeader = styled.div`
  display: flex;
  gap: 12px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 20px;
`;

export const TabButton = styled.button<{ active: boolean }>`
  padding: 10px 16px;
  font-weight: 500;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 2px solid ${(p) => (p.active ? "#2563eb" : "transparent")};
  color: ${(p) => (p.active ? "#2563eb" : "#6b7280")};

  &:hover {
    color: #2563eb;
  }
`;

export const TabWrapper = styled.div`
  padding-top: 16px;
`;
